/**
 * @generated SignedSource<<387cafc7f0d8abe4338c881c87b79ce2>>
 * @relayHash b131db2943fbe0a7111ea95e42cb241e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ab87fdfd3df1197c5639d38f9b64051b30ad7d932961454b067e26ab482b6d4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2ab87fdfd3df1197c5639d38f9b64051b30ad7d932961454b067e26ab482b6d4",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
